// 不处理
const blackList = ['ossgw', 'ae01'];
// 统一文件类型
const blackType = ['imgextra'];
const resetUrl = (imageUrl: string, size?: string, custom?: string) => {
  try {
    if (!imageUrl) return;
    blackList.map((i:string) => {
      if (imageUrl.indexOf(i) > -1) {
        throw new Error('Image Block');
      }
    })
    // 清理图片尺寸
    const imgArr = imageUrl.split('_');
    const _length = imgArr.length;
    // 如果后两位都含有图片后缀
    if (_length > 1) {
      if (imgArr[_length -1].split('.').slice(-1)[0] === imgArr[_length -2].split('.').slice(-1)[0])
      return resetImage(imgArr.slice(0, -1).join('_'), size, custom);
    }
    return resetImage(imageUrl, size, custom);
  } catch (error) {
    return imageUrl;
  }
};

const resetImage = (url: string, size?: string, custom = "") => {
  try {
    if (!url) return;
    blackList.map((i:string) => {
      if (url.indexOf(i) > -1) {
        throw new Error('Image Block');
      }
    })
    let pathUrl = url;
    if (size) {
      const urlArr = url.split('.').slice(-1);
      // 过滤特殊图片不支持后缀
      try {
        blackType.map((i:string) => {
          if (url.indexOf(i) > -1) {
            throw new Error('Type Block');
          }
        })
        pathUrl = `${url}_${size}x${size}${custom}.${urlArr[0]}`;
      } catch (error) {
        pathUrl = `${url}_${size}x${size}${custom}.jpg`;  
      }
    }
    // webp
    if (url.indexOf("@") > 0) return pathUrl;
    if (pathUrl.indexOf("alicdn.com") > 0) {
      return pathUrl
        .replace(".alicdn.com", "")
        .replace("//", "//s.alicdn.com/@");
    }
    return pathUrl;
  } catch (error) {
    return url;
  }
};

export { resetImage, resetUrl };
